import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface Configuration {
    id: number;
    variable: string;
    value: string;
    validFrom: string | null;
    validThru: string | null;
    isValid: boolean;
    information: string;
    createdBy: string | null;
    createdAt: string;
    updatedAt: string;
}

interface ConfigurationState {
    configuration: Configuration[];
}

const initialState: ConfigurationState = {
    configuration: [],
};

const configurationSlice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setConfiguration: (state, { payload }: PayloadAction<Configuration[] | null>) => {
            state.configuration = payload ?? [];
        },
    },
});

export const { setConfiguration } = configurationSlice.actions;

export default configurationSlice.reducer;
